export enum ActionType {
    EditPrincipal = 0,
    EditEntity = 1,
    EditBorrowerEntityToPrincipalLink = 2,
    DeleteBorrowerEntityToPrincipalLink = 3,
    EditCompany = 4,
    RemoveCompany = 5,
    RemovePrincipal = 6,
    RemoveEntity = 7,
    RestoreCompany = 8,
    RestorePrincipal = 9,
    RestoreEntity = 10,
    DeleteCompany = 11,
    DeletePrincipal = 12,
    DeleteEntity = 13,
    SendPasswordResetEmail = 14,
    PrincipalExperience = 15,
    EntityAuditHistory = 16,
    DeleteBusinessToPrincipalLink = 17,
    EditGeneralContractor = 18,
}
